import { mountPage } from '@/main';
import DashboardPage from './DashboardPage.vue';

mountPage(DashboardPage);
